import type { ActionFilter, EventFilter } from "../FilterTypes";
import {
  EABFilterImplementationType,
  SQDCEventActionTypeFieldType,
  type SQDCEventTypeFieldRelation,
  type FilterOption,
} from "@/graphql";
import CustomAttributeBadge from "../ui/badges/CustomAttributeBadge.vue";
import CustomAttributeFilterUI from "../ui/CustomAttributeFilterUI.vue";

export default class CustomAttributeFilter implements EventFilter, ActionFilter {
  constructor(
    public readonly fieldId: number,
    public readonly fieldType: SQDCEventActionTypeFieldType,
    public readonly value: unknown,
    public readonly relationType?: SQDCEventTypeFieldRelation,
    public readonly isNegated?: boolean,
  ) {}

  static readonly Badge = CustomAttributeBadge;

  static readonly UI = CustomAttributeFilterUI;

  getEventFilter(): FilterOption | undefined {
    return {
      filter: {
        type: EABFilterImplementationType.EVENT_CUSTOM_ATTR,
        value: {
          typeId: this.fieldId,
          eventType: this.fieldType,
          relationType: this.relationType,
          value: this.value,
          negated: this.isNegated ?? false,
        },
      },
    };
  }

  getActionFilter(): FilterOption | undefined {
    return {
      filter: {
        type: EABFilterImplementationType.ACTION_CUSTOM_ATTR,
        value: {
          typeId: this.fieldId,
          eventType: this.fieldType,
          relationType: this.relationType,
          value: this.value,
          negated: this.isNegated ?? false,
        },
      },
    };
  }
}
